import {
  fetchNetworkContacts,
  addNetworkContact,
  updateNetworkContact,
  deleteNetworkContact,
} from '@/api/network-contacts'

export const MUTATION_TYPES = {
  SET_CONTACTS: 'NETWORK_CONTACTS/SET_CONTACTS',
  ADD_CONTACT: 'NETWORK_CONTACTS/ADD_CONTACT',
  REMOVE_CONTACT: 'NETWORK_CONTACTS/REMOVE_CONTACT',
  UPDATE_CONTACT: 'NETWORK_CONTACTS/UPDATE_CONTACT',
  SET_LOADING: 'NETWORK_CONTACTS/SET_LOADING',
}

export const ACTION_TYPES = {
  FETCH: 'NETWORK_CONTACTS/FETCH',
  ADD_CONTACT: 'NETWORK_CONTACTS/ADD_CONTACT',
  REMOVE_CONTACT: 'NETWORK_CONTACTS/REMOVE_CONTACT',
  UPDATE_CONTACT: 'NETWORK_CONTACTS/UPDATE_CONTACT',
}

export default {
  state: {
    contacts: {},   // keyed by elastic_id (string) for O(1) star lookups
    loaded: false,
    loading: false,
  },
  getters: {
    networkContacts (state) {
      return Object.values(state.contacts).sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
    },
    isNetworkContact (state) {
      return (elasticId) => !!state.contacts[elasticId]
    },
    networkContactsLoaded (state) {
      return state.loaded
    },
  },
  mutations: {
    [MUTATION_TYPES.SET_CONTACTS] (state, contacts) {
      state.contacts = Object.fromEntries(contacts.map(c => [c.elastic_id, c]))
      state.loaded = true
      state.loading = false
    },
    [MUTATION_TYPES.ADD_CONTACT] (state, contact) {
      state.contacts = { ...state.contacts, [contact.elastic_id]: contact }
    },
    [MUTATION_TYPES.REMOVE_CONTACT] (state, elasticId) {
      const updated = { ...state.contacts }
      delete updated[elasticId]
      state.contacts = updated
    },
    [MUTATION_TYPES.UPDATE_CONTACT] (state, contact) {
      const existing = state.contacts[contact.elastic_id] ?? {}
      state.contacts = { ...state.contacts, [contact.elastic_id]: { ...existing, ...contact } }
    },
    [MUTATION_TYPES.SET_LOADING] (state, loading) {
      state.loading = loading
    },
  },
  actions: {
    async [ACTION_TYPES.FETCH] ({ commit, state }) {
      if (state.loaded) return
      commit(MUTATION_TYPES.SET_LOADING, true)
      try {
        const contacts = await fetchNetworkContacts()
        commit(MUTATION_TYPES.SET_CONTACTS, contacts)
      } catch {
        commit(MUTATION_TYPES.SET_LOADING, false)
      }
    },
    async [ACTION_TYPES.ADD_CONTACT] ({ commit }, { elasticId, name, role, image }) {
      const contact = await addNetworkContact(elasticId)
      // Merge local display fields in case the API response is missing them (e.g. actor not yet indexed)
      commit(MUTATION_TYPES.ADD_CONTACT, {
        name,
        role,
        image,
        ...contact,
      })
    },
    async [ACTION_TYPES.REMOVE_CONTACT] ({ commit }, elasticId) {
      await deleteNetworkContact(elasticId)
      commit(MUTATION_TYPES.REMOVE_CONTACT, elasticId)
    },
    async [ACTION_TYPES.UPDATE_CONTACT] ({ commit }, { elasticId, phone, notes }) {
      const contact = await updateNetworkContact(elasticId, { phone, notes })
      commit(MUTATION_TYPES.UPDATE_CONTACT, contact)
    },
  },
}
